import React from 'react';
import { Icon } from '@material-ui/core';

export interface UpdateDateProps {
  size: 'small' | 'medium';
  updateDate: string;
  labelType?: 'update' | 'create' | 'deadline';
  offMarginRight?: boolean;
  isDanger?: boolean;
}

const UpdateDate: React.FC<UpdateDateProps> = ({ size, updateDate, labelType, offMarginRight, isDanger }) => {
  const labelTextBase = !labelType ? null : labelType === 'update' ? '更新' : labelType === 'create' ? '作成' : '期限';
  const labelText = `${labelTextBase} : `;
  const labelClassName = `u-text-middle ${size === 'small' ? 'u-text-s' : 'u-text-m'}${isDanger ? ' u-text-danger' : ''}`;
  const dateClassName = `u-text-middle ${size === 'small' ? 'u-text-s' : offMarginRight ? 'u-text-m' : 'u-text-m u-mr16'}${
    isDanger ? ' u-text-danger' : ''
  }`;
  const labelTestId = `${labelType}Date-label`;
  const dateTestId = `${labelType ? labelType : 'update'}Date`;

  return (
    <>
      {!labelType ? (
        <Icon data-testid='updateDate-icon' data-testid-e2e='updateDate-icon' className='u-text-l u-text-middle u-mr4'>
          update
        </Icon>
      ) : (
        <span className={labelClassName} data-testid={labelTestId} data-testid-e2e={labelTestId}>
          {labelText}
        </span>
      )}
      <span className={dateClassName} data-testid={dateTestId} data-testid-e2e={dateTestId}>
        {updateDate}
      </span>
    </>
  );
};

export default UpdateDate;
